import { render } from "./ban-ve-tren-xe.vue?vue&type=template&id=4f55de98"
import script from "./ban-ve-tren-xe.vue?vue&type=script&lang=js"
export * from "./ban-ve-tren-xe.vue?vue&type=script&lang=js"

import exportComponent from "/source/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__